<template>
  <section>
    <b-row >
      
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Listados de Servicios
                  </div> 
                </template> 
                    <b-row style="margin-bottom:5px;padding:15px;background: rgba(0, 80, 166, 0.03);border: 1px ridge;">                               
                        <b-col :md="4">                          
                          <b-input-group  class="filter-sw-group" size="sm" prepend="Razón">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_razon"                   
                              :options="filterSelects('datos_razon')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group> 
                          <b-input-group  class="filter-sw-group" size="sm" prepend="Centro">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_contacto"                   
                              :options="filterSelects('datos_contacto')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group> 
                        </b-col>
                        <b-col :md="4">
                         <b-input-group  class="filter-sw-group" size="sm" prepend="Asesor">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_asesor"                   
                              :options="filterSelects('datos_asesor')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group> 
                        </b-col>                         
                        <b-col :md="4">                          
                          <b-input-group class="filter-sw-group" size="sm" prepend="Seleccionar servicio"  >
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                              v-model="filter.name"                   
                              :options="serviciosMultiples()"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              @input="filter.id_list=null"
                              >
                              </c-multiselect>
                          </b-input-group> 
                           <div>         
                            <b-input-group class="filter-sw-group" size="sm" prepend="Periodo:" style="margin-bottom:5px">
                              <c-multiselect
                                style="display:inline-block;flex: 1 1 0%"   
                                v-model="mes"                   
                                :options="lists.list_mes"
                                :allow-empty="false"
                                label="name"
                                track-by="name"
                                :preselect-first="false"
                                :searchable="true"
                                placeholder="Mes"
                                >
                              </c-multiselect>
                              <c-multiselect
                                style="display:inline-block;flex: 1 1 0%"   
                                v-model="ano"                   
                                :options="lists.list_ano"
                                :allow-empty="false"
                                label="name"
                                track-by="name"
                                :preselect-first="false"
                                :searchable="true"
                                placeholder="Año"
                                >
                              </c-multiselect>
                            </b-input-group> 
                          </div>           
                        </b-col>              
                    </b-row> 
                    <b-row align-h="end">
                      <b-col :md="6" class="text-right">
                        <b-button @click="getLimpiar()" :disabled="statusLoading" size="sm" class="mr-2" variant="outline-secondary">Limpiar</b-button>
                        <b-button @click="openExcell()" :disabled="statusLoading || filter.name===null" size="sm" variant="success"  class="mr-2" >Excell</b-button>                        
                        <b-button  :disabled="statusLoading || filter.name===null" @click="openPdf()" size="sm" variant="secondary"  class="mr-2" >Pdf</b-button>
                      </b-col>  
                      <b-col :md="12">  
                        <sw-loading v-if="statusLoading"></sw-loading>  
                        <b-alert
                          style="margin-top:10px"
                          v-if="statusDescargar"
                          v-model="statusDescargar"
                          variant="warning"
                          dismissible
                        >
                          <p class="text-center">No se encontrarón resultados</p>
                      </b-alert>   
                      </b-col>                    
                    </b-row>          
            </b-card>           
      </b-col>      
    </b-row>  
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwLoading from '@/components/notification/loading.vue'
import SwModalanularafiliacion  from '@/components/modals/anularAfiliacion.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    'c-multiselect': Multiselect,
    SwModalanularafiliacion,
    SwModalafiliacion,
    SwLoading
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
<style>
.custom-control-inline
{
  margin-right:6px !important;
}
.table-pdf td {
  font-size:11px !important
}
.table-pdf th{
  font-size:12px !important
}
</style>
